import type { HTMLAttributes } from 'react';

/** Page content wrapper. `--container-landing` is the *content* width the design
 *  grid is drawn on (1200px); the box itself is that plus the `lg` gutter on
 *  both sides, so from 1264px up the content measures exactly 1200px — matching
 *  every section in the Figma frames. Below that the gutter eats into the
 *  viewport instead, keeping content off the screen edges. */
export function Container({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`max-w-landing-box mx-auto w-full px-4 sm:px-6 lg:px-8 ${className}`}
      {...props}
    />
  );
}
